export default defineNuxtPlugin(async () => {
  const auth = useAuth()
  const shopConfigStore = useShopConfigStore()

  const result = await shopConfigStore.loadConfig()
  if (isErr(result)) {
    throw createError({ statusCode: 500, fatal: true })
  }

  if (auth.loggedIn.value) {
    const { initialDataLoad } = useInitialDataLoad()
    await initialDataLoad()
  }
})
